import { FC } from "react";

import Box from "@mui/material/Box";

export const G2ButtonLogo: FC = () => (
  <Box component="svg" viewBox="0 0 20 20" sx={{ width: 20, height: 20, flexShrink: 0 }}>
    <circle cx="10" cy="10" r="10" fill="#FF492C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.33 7.66h-1.71c.05-.27.21-.42.55-.59l.31-.16c.56-.29.86-.61.86-1.14 0-.34-.13-.6-.39-.79a1.3 1.3 0 00-.92-.28c-.28 0-.54.07-.78.22-.23.14-.41.33-.52.56l.5.49c.19-.39.47-.57.84-.57.31 0 .5.16.5.38 0 .19-.09.34-.45.52l-.2.1c-.44.22-.75.47-.92.76-.17.28-.26.65-.26 1.09v.12h2.59v-.71zM14.1 9.18h-2.83l-1.41 2.45h2.83l1.41 2.45 1.41-2.45-1.41-2.45zM10.1 13.26A3.27 3.27 0 016.84 10a3.27 3.27 0 013.27-3.26l1.12-2.34c-.36-.07-.74-.11-1.12-.11A5.71 5.71 0 004.39 10a5.71 5.71 0 005.72 5.71c1.26 0 2.42-.41 3.37-1.1l-1.24-2.14a3.23 3.23 0 01-2.13.8z"
      fill="white"
    />
  </Box>
);
